export default __webpack_public_path__ + "static/media/fimAberturaKids.caeb2860.png";